export default "/biometrie-afghanistan/media/4040e7efbc456c03d3ffa1d42affc20f~matthias.jpg";